import { render, staticRenderFns } from "./SaleSkinModal.vue?vue&type=template&id=4812b291&scoped=true&"
import script from "./SaleSkinModal.vue?vue&type=script&lang=js&"
export * from "./SaleSkinModal.vue?vue&type=script&lang=js&"
import style0 from "./SaleSkinModal.vue?vue&type=style&index=0&id=4812b291&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812b291",
  null
  
)

export default component.exports